var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080.02 177.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M821.77,177.36c.05-15.58.1-31.15.14-46.73v-3.72c1.11-.07,1.99-.1,2.87-.14v50.62h-3.03l.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1080,147.75c-.14.97-.45,1.97-.4,2.94.07,2.04-.74,2.8-2.9,2.11v-23.83c1.84-.32,2.79.35,2.87,1.99.15,3.18.29,6.35.45,9.55v7.25l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.85,7.21h3.13v153.25c-2.7.57-2.75.57-2.82-1.92-.14-3.91-.28-7.85-.28-11.76V7.21h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.71,150.29V0h3.22v3.01c0,47.82,0,95.61.05,143.43,0,2.23-.4,3.75-3.25,3.84h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.58,176.32c-2.04.71-2.92.14-2.92-1.97,0-4.13-.26-8.25-.26-12.38V26.55h3.18v149.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.51,8.42c.95-.05,1.83-.09,3.15-.17v3.03c0,45.99,0,92.01.05,138,0,2.25-.36,3.72-3.2,3.46V8.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.23,165.48c-2.06.69-2.85,0-2.85-2.06,0-4.03-.26-8.04-.26-12.07V18.71c1.14-.05,2.02-.09,3.11-.17v146.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.24,153.58c-.99.05-1.87.1-2.96.14V19.3c.9-.05,1.85-.09,2.96-.14v134.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.75,165.41V32.22c1.99-.83,2.96-.43,2.99,1.9.02,5.83.26,11.66.26,17.52.02,32.84.02,65.67,0,98.48,0,4.43-.24,8.84-.26,13.28,0,2.06-.81,2.75-2.99,1.99v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.01,24.85v127.24c-2.3-1.07-3.25-2.51-3.25-4.98.05-39.17.05-78.33.05-117.52,0-1,.21-1.99.21-3.01,0-2.06,1.14-2.3,2.99-1.75v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M654.7,42.56c1.09-.07,1.97-.14,3.03-.21v125.56c-1.61.4-2.89.5-2.89-1.83,0-1.21-.24-2.39-.24-3.6V44.43c0-.5.05-1,.1-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M647.33,42.84c1.14-.07,2.01-.12,3.1-.19v122c-2.58.62-2.66.62-2.82-1.85-.17-2.7-.28-5.43-.28-8.13V42.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M843.91,40.64c1.26.14,2.04.24,3.15.38v110.15c0,2.7-.17,5.43-.28,8.13-.12,2.21-.14,2.21-2.87,1.87V40.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M836.57,161.24V40.47c1.02-.05,1.97-.09,3.22-.17v107.64c0,3.72-.24,7.44-.26,11.17,0,1.99-.64,2.87-2.96,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M640.05,42.91h3.15v116.9c-2.65.62-2.7.62-2.87-1.85-.17-2.39-.29-4.81-.29-7.23V42.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.1,39.78c1-.05,1.87-.09,3.18-.17v108.77c0,1.4-.24,2.8-.24,4.22,0,2.09-.9,2.68-2.94,1.97V39.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M901.93,160.57v-2.54c0-36.25,0-72.5-.05-108.73,0-2.13.38-3.53,3.2-3.49.05,1,.14,2.04.14,3.08v100.29c0,3.11-.26,6.24-.26,9.34,0,2.04-.73,2.8-3.06,2.04h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M912.55,43.48v104.88c0,2.42-.26,4.84-.26,7.23,0,2.11-.85,2.68-2.94,1.99-.05-.85-.12-1.73-.12-2.63,0-36.06,0-72.12-.05-108.18,0-2.16.36-3.56,3.37-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.08,42.22c1.16-.05,2.04-.09,3.13-.14v113.54c-2.77.62-2.8.62-2.82-2.51-.12-14.98-.24-29.99-.29-44.97-.05-20.72,0-41.47,0-62.19v-3.72h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.93,153.41c-1.92.47-3.13.38-3.13-2.11.05-36.13.02-72.24.02-108.68.97-.14,1.92-.26,3.08-.43v111.21h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M931.18,39.64c1.14.07,2.01.12,3.01.17v110.84h-3.01V39.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M854.09,152.85c-.92.14-1.8.29-2.87.47V42.18c2.02-.17,3.18.19,3.18,2.51-.05,35.73-.05,71.46-.07,107.18,0,.19-.09.38-.24.95v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M926.94,150.5h-2.99V40.47c.97-.07,1.9-.12,2.99-.19v110.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.29,153.51c-2.32.52-3.2-.07-3.2-2.35.05-34.83.07-69.63,0-104.46,0-2.42,1.33-2.75,3.22-3.18v109.98h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M723.41,153.77c-2.21-.07-3.34-.78-3.34-3.06.05-35.75.02-71.53.05-107.28,0-.28.12-.57.24-1.04h3.58c-.52,7.16-1.04,14.11-1.54,21.05-.05.81-.07,1.61,0,2.39.33,4.5.97,8.99,1,13.49.09,23.68.05,47.35.05,71.03v3.41h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M919.57,150.57c-.9.05-1.78.12-2.87.19V42.27c.73-.26,1.64-.55,2.87-.97v109.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1014.33,153.56c-1.28-.24-2.16-.38-3.15-.57-.05-1-.12-1.87-.12-2.77,0-34.92,0-69.84-.05-104.79,0-2.28.47-3.7,3.41-3.65-.35,37.1.17,74.21-.09,111.76v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.63,151c-1.87.47-3.11.43-3.11-2.09.05-35.02.02-70.03.02-105.05,0-.28.12-.57.24-1.04.85-.05,1.73-.12,2.82-.19v108.39l.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M454.75,41.66c-.52,10.34-1.02,20.37-1.52,30.37-.05,1.21-.12,2.42-.07,3.63.36,8.42.95,16.81,1.04,25.23.17,16.31.05,32.65.05,48.96v3.65c-1.21-.17-2.13-.31-3.2-.45-.05-1.02-.12-1.9-.12-2.8,0-34.95,0-69.91-.05-104.86,0-2.35.59-3.6,3.86-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M446.83,45.02v106.62c-2.61-.07-3.22-1.33-3.22-3.67.07-32.81.07-65.62,0-98.44,0-2.32.52-3.91,3.2-4.53l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1006.98,45.07v106.57c-2.4-.19-3.27-1.18-3.27-3.63.09-32.84.07-65.65,0-98.48,0-2.39.71-3.82,3.27-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M858.38,151.12V45.26c2.23.71,3.3,1.9,3.27,4.29-.05,32.72-.05,65.43,0,98.15,0,2.28-.73,3.37-3.29,3.41h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.08,47.32v104.77c-2.32-.07-3.3-.95-3.3-3.44.07-32.31.07-64.63,0-96.94,0-2.28.81-3.58,3.27-4.39h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.41,42.48c1.21.09,2.06.17,3.04.26v104.98c-2.7.59-3.04.52-3.08-2.13-.1-8.56,0-17.12,0-25.68,0-3.91-.1-7.85-.1-11.76v-63.16c0-.69.07-1.38.14-2.49v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M715.99,42.84v101.8c-.19.07-.38.14-.59.21-.88-3.18-2.47-6.33-2.49-9.51-.19-30.02-.09-60.03-.14-90.04,0-2.37.59-3.44,3.23-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439.5,148.03c-2.46-.88-3.18-2.44-3.15-4.88.07-28.9.07-57.8,0-86.72,0-2.61.83-4.41,3.18-5.93v97.51l-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M999.61,147.91c-2.32-.83-3.15-2.23-3.13-4.58.07-29.07,0-58.16.14-87.22,0-1.83,1.28-3.63,1.97-5.45.36.12.71.21,1.04.33v96.94l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.63,148.58c-2.23-.76-3.11-2.06-3.11-4.46.07-28.47,0-56.95.14-85.42,0-1.83,1.23-3.67,1.9-5.5.36.09.71.19,1.07.31v95.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.3,70.37c.78,6.28,2.18,12.57,2.28,18.87.29,22.55.12,45.07.12,67.62v3.56c-2.96.64-3.01.64-3.04-2.46-.12-21.34-.21-42.65-.28-63.99-.02-7.82,0-15.65,0-23.47.31-.05.64-.07.95-.12h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.78,33.33v108.77c-.95.45-1.92.9-3.15,1.49,0-6.07-1.14-12.16.31-17.57,1.64-6.19,2.06-12.23,1.94-18.44-.02-1.63-1.16-3.22-1.73-4.86-.29-.81-.57-1.66-.59-2.51-.07-4.03-.02-8.06,0-12.09,0-.69-.12-1.49.19-2.09,3.82-7.56,2.89-15.1.1-22.69-.17-.45-.26-.97-.26-1.47.07-8.96.21-17.9.26-26.86,0-2.13,1.14-2.25,2.96-1.71l-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M866.72,53.89c.73,4.41,2.06,8.8,2.06,13.21,0,14.51-.73,29-.78,43.5-.02,11.14.59,22.31.88,33.45.07,2.75,0,2.75-3.15,3.93V54.05c.33-.05.66-.12,1-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M378.5,42.13h3.01v75.58c0,2.87-.9,5.31-3.03,7.4V42.13h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M705.53,42.84c1.18-.07,2.06-.12,3.13-.17v82.13c-.24.07-.5.12-.73.19-.81-3.82-2.25-7.61-2.3-11.43-.21-22.33-.12-44.67-.12-67v-3.7l.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M817.86,90.97v80.3c-2.89.74-2.92.71-2.94-2.7-.09-23.26-.19-46.49-.28-69.75,0-1.61.12-3.22-.02-4.84-.24-2.47.92-3.22,3.25-3.03v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M662.03,70.53c2.04,7.02,3.41,14.06,3.29,21.5-.31,19.42-.09,38.83-.09,58.25v3.77h-3.2v-83.55.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M432.2,141.3c-1.92-2.09-3.15-3.91-3.15-6.71.1-21.95.12-43.88,0-65.84,0-3.41.76-6.31,3.15-9.15v81.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M992.33,141.23c-1.85-2.16-3.18-3.98-3.15-6.78.09-22.36,0-44.71.14-67.07,0-2.54,1.38-5.05,2.11-7.56.28.07.59.14.88.21v81.2h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M683.96,42.2h3.06v3.7c0,21.84.1,43.67-.09,65.51-.02,3.51-1.45,6.99-2.23,10.5-.24-.07-.47-.14-.73-.21V42.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.47,62.92v78.57c-.28.12-.57.24-.83.36-.78-2.06-2.23-4.15-2.25-6.21-.17-21.83-.19-43.67,0-65.51,0-2.49,1.49-4.95,2.3-7.42.26.07.52.14.81.24l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M635.97,98.63c-2.21-4.77-3.3-9.06-3.25-13.85.19-20.44.07-40.87.07-61.33v-3.53c1.14-.05,2.06-.09,3.18-.14v78.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M771.11,103.2V32.03h3.22v56.71c0,4.13-.24,8.23-.26,12.35,0,2.01-.71,2.82-2.96,2.09v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.95,163.59c-2.2.76-3.13.17-3.08-1.92,0-.9-.21-1.8-.21-2.7v-66.15c2.04,1.64,3.44,2.92,3.41,5.76-.17,20.6-.1,41.23-.1,61.85v3.18l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M749.32,113.8V42.22c1-.05,1.85-.09,3.2-.17v3.65c0,18.54-.09,37.06.07,55.6.05,4.39-.85,8.32-3.27,12.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M494.69,89.97V23.57h3.22v3.06c0,19.91-.02,39.85.05,59.77,0,2.28-.43,3.67-3.25,3.58h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M810.44,160.65c-2.04.69-2.8-.02-2.8-2.09-.07-20.74-.21-41.49-.17-62.23,0-1.07,1.35-2.11,2.09-3.18.31.14.59.28.9.45v67.05h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M727.6,85.3c2.44,3.82,3.22,7.75,3.18,12.11-.19,17.71-.12,35.42-.05,53.13,0,2.18-.47,3.51-3.13,3.49v-68.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.77,72.97c-1.71.5-2.89.5-2.89-1.66V8.46h2.89v64.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M385.61,109.03V42.2h3.15v3.34c0,16.9-.12,33.78.07,50.69.05,4.48-.97,8.49-3.25,12.8h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M778.39,92.32V27.19h3.22v50.66c0,4.13-.24,8.23-.26,12.35,0,2.02-.69,2.82-2.96,2.09v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.29,90.23v4.48c0,18.02-.02,36.06.05,54.08,0,2.13-.45,3.51-3.18,3.56-.07-.95-.19-1.87-.19-2.82,0-18.63.02-37.27-.05-55.88,0-2.42.64-3.63,3.39-3.41h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.9,153.46c-.97.09-1.85.17-3.2.31v-3.08c0-18.11.05-36.25-.05-54.36,0-2.42.74-3.56,3.25-3.6v60.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M691.12,105.41v-62.66h3.2v3.46c0,15.88-.14,31.77.1,47.65.07,4.15-1.35,7.52-3.29,11.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1054.8,163.68v-59.7h3.22v53.39c0,1.49-.23,3.01-.23,4.5,0,2.06-1.07,2.35-2.97,1.8h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M698.25,42.75c1.28.07,2.16.12,3.18.17v61.93c-.26.07-.54.12-.81.19-.78-3.7-2.2-7.4-2.25-11.12-.26-15.81-.12-31.63-.12-47.44v-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M803.3,97.13v58.63c-1.66.45-2.94.59-2.96-1.75,0-1.21-.24-2.42-.24-3.6,0-16.31.02-32.65-.07-48.96,0-2.3.71-3.63,3.27-4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.41,100.69v58.51c-2.13,1.11-2.99.4-3.01-1.82-.05-3.72-.21-7.45-.24-11.17-.02-13.58.05-27.17-.05-40.75,0-2.51,1.23-3.68,3.29-4.79v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M984.29,126.6c-.78-5.83-2.09-11.64-2.23-17.5-.33-14.06-.1-28.14-.1-42.22v-3.44h3.2v63.09c-.28,0-.57.05-.85.07h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M414.7,54.34h2.89v57.37h-2.89v-57.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M487.53,34.99h2.94c.05.9.14,1.78.14,2.66,0,17,0,34,.05,51,0,2.16-.35,3.58-3.13,3.2v-56.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.5,153.37c-2.3.28-3.13-.5-3.13-2.8.07-16.9.07-33.81,0-50.71,0-2.23.81-3.37,3.13-3.84v57.37-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M669.3,151.64v-58.77c2.12,1.49,3.18,3.49,3.18,6,0,15.62-.05,31.22.05,46.85,0,2.56-.92,4.34-3.22,5.9v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M954.96,92.82c-.71-1.38-1.99-2.73-2.02-4.1-.14-17.33-.09-34.64-.07-51.97,0-.28.09-.59.19-1.11.92-.05,1.85-.09,2.96-.14v56.85c-.36.17-.71.33-1.07.5v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M422.05,65.81h2.92v61.29c-.17.05-.36.1-.52.14-.88-4.86-2.39-9.7-2.49-14.56-.33-15.2-.12-30.42-.1-45.61,0-.38.12-.76.21-1.26h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M967.55,44.05h2.89v55.55h-2.89v-55.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.91,145.4c0-17.4-.14-34.83.12-52.23.05-3.01,1.73-6.02,3.2-8.89v38.22c0,3.72.26,7.47-.07,11.17-.38,4.01-1.3,7.94-1.99,11.9-.43-.07-.83-.12-1.26-.19v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1032.99,96.33v-54.98c.23-.21.47-.4.73-.62.83.97,2.4,1.94,2.4,2.94.14,17.19.11,34.35.11,51.71-1.01.31-1.92.57-3.22.95h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476.08,95.4c-1.09.31-1.94.55-3.08.85v-55c1.56.19,3.13.09,3.13,2.56-.07,17.12-.02,34.21-.02,51.59h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M407.4,96.54v-54.29h3.2v47.72c0,1.49-.24,3.01-.21,4.5.02,2.04-.81,2.77-2.96,2.04l-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.99,167.29c-2.02.69-2.82.07-2.85-2.02-.07-15.48-.31-30.94-.17-46.42.02-2.96,1.54-5.9,2.99-8.75v57.18h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M745.22,69.49c0,17.73.12,34.97-.12,52.18-.05,2.94-1.54,5.83-2.37,8.75-.29-.05-.57-.12-.85-.17v-10.41c0-10.08.28-20.15-.09-30.2-.26-6.88,1.11-13.32,3.41-20.15h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M887.54,116h2.92v52.54c-1.09.07-1.92.12-2.92.17v-52.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M734.62,147.11v-29.78c0-6.14.12-12.28-.05-18.4-.07-3.03.17-5.76,3.2-7.68.07.59.17,1.21.17,1.83,0,15.2.14,30.39-.1,45.57-.05,2.92-1.54,5.78-2.37,8.68-.28-.07-.57-.14-.83-.21h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.37,93.03c-1.21.07-2.09.12-3.15.19v-52.37c1.85-.02,3.18.36,3.15,2.61-.02,16.38,0,32.76,0,49.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M960.25,40.97c2.47.5,3.25,1.68,3.25,3.89-.09,15.08-.07,30.18,0,45.28,0,2.32-.64,3.44-3.22,2.87v-52.02l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M756.57,96.3v-53.51h3.2v3.44c0,13.28.14,26.53-.09,39.81-.07,3.53-1.38,7.04-2.11,10.57-.33-.09-.66-.21-1-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M480.11,93.88v-51c1.02-.05,1.97-.12,3.08-.17.07,1.09.14,1.99.14,2.87,0,15.01-.05,30.01.05,45.02,0,2.49-.71,3.56-3.3,3.27h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M796.07,103.11v52.56c-1.97.83-2.96.47-2.99-1.87-.07-15.48-.24-30.94-.17-46.42,0-1.59,1.45-3.18,2.23-4.74.31.17.62.33.92.5v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.97,87.74v-50.31c1-.05,1.87-.09,2.96-.14v50.31c-.88.05-1.83.12-2.96.17v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.44,68.82c-1.97.4-3.15.28-3.13-2.04.07-15.6,0-31.22.02-46.82,0-.38.12-.78.19-1.28h2.92v50.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M785.71,38.62h2.92c.07.5.24.97.24,1.45v45.88c0,2.18-.43,3.6-3.18,2.77v-50.1h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.97,41.01v51.07c-2.09-1.19-3.22-2.49-3.2-4.79.05-14.51.07-28.99,0-43.5,0-2.35.97-3.03,3.22-2.77h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.99,111.14c.76-.02,1.64-.07,2.73-.12v50.17c-1.59.57-2.82.59-2.82-1.73-.05-15.96-.12-31.93-.17-47.89,0-.09.1-.17.26-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1040.29,93.93v-49.86c2.51.5,3.27,1.83,3.25,4.24-.12,14.11-.12,28.21,0,42.3,0,2.47-.67,3.6-3.25,3.3v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.3,78.52h2.84v50.07c-1.66.47-2.84.47-2.84-1.83-.07-15.77-.17-31.53-.26-47.3,0-.28.14-.57.26-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M679.76,85.28c0,15.6.12,30.49-.12,45.4-.05,2.61-1.59,5.17-2.44,7.75-.26-.07-.52-.12-.76-.19v-23.76c0-5.83.21-11.69-.07-17.52-.19-4.13.88-7.68,3.39-11.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.53,101.52c.81,3.27,1.73,7.07,2.66,10.86.21.88.5,1.75.5,2.63.02,12.68,0,25.34,0,38.03,0,.29-.12.57-.19,1.04h-2.96v-52.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.17,146.18c-1.71.28-3.18.64-3.15-1.85.05-14.18,0-28.38,0-42.82,1.09-.05,2.04-.12,3.15-.17v44.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.82,90.35v-47.51h3.22v5.41c0,10.57.19,21.15-.12,31.72-.1,3.53-1.49,7.04-2.3,10.57l-.83-.19h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1062.12,115.39h2.9c.09.36.26.74.26,1.11-.07,13.96-.19,27.9-.24,41.87,0,2.06-.57,3.08-2.92,2.21v-45.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M625.52,31.34h3.18v47.44c-.24.07-.5.14-.74.21-.81-3.6-2.23-7.18-2.32-10.81-.28-12.16-.12-24.35-.12-36.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.44,60.03c.33,2.84.97,5.69.92,8.51-.28,15.2-.78,30.39-1.14,45.59-.07,3.01-.05,6.05,2.56,8.35.45.4.4,1.47.4,2.25.02,6.05-.1,12.09.07,18.14.07,2.39-1,3.41-3.22,4.03V60.1c.14,0,.26-.05.4-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M611.13,116.6h2.99v42.27h-2.99v-42.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M548.68,158.94h-2.99v-42.27h2.99v42.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.33,115.96h3.15v42.2c-2.18.83-2.92,0-2.94-2.13-.05-7.14-.17-14.25-.21-21.38-.05-6.12,0-12.23,0-18.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.95,158.82v-42.15h3.23v5.71c-.07,11.45-.19,22.88-.24,34.33,0,1.99-.74,2.82-2.99,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M589.53,116.6h2.8v42.32h-2.8v-42.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M880.23,146.75v-42.18h3.2v10.6c-.07,9.84-.19,19.68-.24,29.52,0,2.06-.83,2.73-2.99,2.09l.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1047.57,91.92v-42.77c2.13,1.45,3.27,2.89,3.22,5.45-.14,11.45-.12,22.9,0,34.35,0,2.23-.73,3.13-3.22,2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M796.12,46.61v38.22c0,1.92-.36,3.53-3.13,2.68v-40.9h3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.36,38.03c1-.05,1.87-.09,2.87-.14.12.57.28,1.04.28,1.49,0,12.16.05,24.3-.05,36.46,0,.83-1.07,1.66-1.64,2.47-.55-.85-1.54-1.68-1.54-2.54-.09-12.04-.07-24.11-.07-36.15,0-.5.09-.97.14-1.61v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M894.79,165.43v-41.56h3.08v30.51c0,3.01-.17,6.02-.14,9.03,0,2.06-.81,2.73-2.94,2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M977.91,55.55v29.75c0,3.11-.17,6.21-.17,9.32,0,2.13-.95,2.58-2.89,1.9v-40.97h3.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M763.83,79.45v-41.39c1.02-.05,1.97-.09,3.22-.14v12.83c0,6.24.26,12.49-.09,18.71-.19,3.44-1.42,6.83-2.18,10.22-.31-.07-.64-.14-.95-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M632.84,116.6h3.11v40.4c-1.8.59-2.87.36-2.89-1.87-.02-10.62-.14-21.27-.21-31.89v-6.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M829.19,166.03c0-12.28-.1-24.42.12-36.56.02-1.68,1.73-3.32,3.08-5.71v31.22c0,3.01-.19,6.02-.14,9.03,0,2.04-.73,2.77-3.06,2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.4,90.09v-42.72c.26-.07.55-.12.81-.19.81,3.51,2.18,6.99,2.32,10.53.35,8.53.26,17.09,0,25.63-.07,2.39-1.33,4.77-2.04,7.14-.38-.12-.74-.24-1.11-.36l.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.32,27.71h2.85v40.42c-1.78.57-2.87.36-2.87-1.87.02-12.73,0-25.46,0-38.55h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.62,38.03h3.03c.05.88.17,1.73.17,2.61,0,10.76-.07,21.55.07,32.31.02,2.39-.83,3.49-3.25,3.77v-38.69h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1018.48,114.23c2.32,2.23,3.34,4.62,3.27,7.8-.21,9.34-.07,18.71-.07,28.07v3.49h-3.18v-39.33l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M461.53,153.6h-3.13v-39.19c1.97,2.18,3.27,4.12,3.22,7.14-.21,9.55-.07,19.11-.07,28.66v3.39h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.94,72.31v-22.36c0-4.91.12-9.84.07-14.75,0-1.99.88-2.49,3.06-1.9v2.75c0,10.05-.07,20.13.05,30.18.02,2.58-.88,4.41-3.2,6.05l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1047.54,146.14v-35.54c1-.07,1.92-.12,3.23-.19v10.69c0,7.33.02,14.68-.03,22,0,1.78.1,3.94-3.17,3.06l-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M948.68,82.43c-3.01-2.54-3.23-5.78-3.15-9.32.17-7.63.14-15.27,0-22.93-.05-2.58.76-4.43,3.15-5.93v38.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.99,42.2h3.13v37.1c-.21.07-.4.14-.62.21-.85-3.56-2.25-7.09-2.42-10.69-.38-7.73-.12-15.51-.12-23.26v-3.39l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.42,83.62c0-10.67-.07-21.12.09-31.56,0-1.19,1.49-2.32,2.3-3.51.31.14.62.28.92.43v9.82c0,7.14-.07,14.27.05,21.43.02,2.23-.64,3.44-3.37,3.41v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.6,80.7c-2.73-1.66-3.25-4.1-3.15-7.11.21-7.14.19-14.27,0-21.41-.07-2.87.74-5.07,3.15-7.02v35.56-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M803.42,50.47c0,10.53.05,21.05-.1,31.56,0,.88-1.38,1.73-2.11,2.58-.28-.19-.57-.38-.85-.55-.09-.55-.26-1.09-.26-1.64,0-9.53-.09-19.06.1-28.59.02-1.3,1.35-2.61,2.09-3.89.38.17.76.36,1.14.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M810.7,46.3c0,10.34.09,20.58-.12,30.84-.02,1.28-1.54,2.54-2.35,3.79-.29-.09-.57-.19-.85-.31v-6.16c0-8.16.07-16.31-.05-24.47-.02-2.37.76-3.58,3.37-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1069.4,123.26c1-.05,1.88-.09,3.18-.14v6.92c-.07,7.82-.14,15.65-.29,23.47-.04,2.51-.11,2.51-2.89,2.28v-32.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.7,79.16c0-10.83-.07-21.08.12-31.32,0-1,1.56-1.97,2.39-2.94.26.17.55.36.81.52v26.46c0,2.53-1.11,4.96-3.32,7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.58,74.82c-.88-2.49-2.42-4.98-2.49-7.49-.31-8.91-.12-17.83-.12-27.03,1.23.26,2.2.47,3.18.69v33.69c-.19.05-.38.09-.55.17l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1028.93,152.96c-1.11.17-2.04.33-3.17.5v-31.37c2.32.33,3.29,1.38,3.24,3.91-.16,8.91-.07,17.85-.07,26.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M465.7,122.14c2.3.43,3.2,1.52,3.15,3.91-.14,8.84-.07,17.69-.07,26.77-1,.24-1.9.45-3.11.74v-31.41h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.88,122.29c2.09,1.54,3.25,3.06,3.2,5.74-.19,8.44-.07,16.86-.07,25.53-1.02.21-1.94.4-3.13.64v-31.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1058.02,89.28c-1.11.36-1.94.62-3.08.97v-32.12c.28-.09.57-.19.83-.26.76,2.56,2.04,5.1,2.13,7.68.29,7.82.1,15.67.1,23.76l.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.91,143.22h-3.2v-19.63c0-2.3.05-4.62,0-6.92-.05-2.28.88-3.13,3.23-2.35v28.9h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400.1,72.76v-30.01c1-.12,1.94-.24,3.2-.38,0,8.58.17,16.88-.12,25.18-.07,1.8-1.71,3.56-2.61,5.31-.14-.02-.31-.07-.45-.09h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.32,54.29v29.68c-2.49.31-3.22-.76-3.2-3.08.09-7.11.12-14.25,0-21.36-.05-2.47,1.14-3.82,3.2-5.22v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.36,127.48h2.85v27.69c-1.42.38-2.82.76-2.82-1.49-.02-8.7,0-17.4,0-26.2h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1033.01,125.01h3.2v6.19c0,5.81-.09,11.64.05,17.45.07,2.44-.62,3.6-3.25,3.2v-26.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M472.86,151.76v-26.7h3.2c0,8.42.07,16.74-.12,25.06,0,.76-1.57,1.49-2.4,2.23-.24-.21-.47-.4-.71-.62l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.82,131.94v28.5c-2.82.57-2.89.57-2.94-1.9-.14-7.51-.33-15.05-.19-22.57.02-1.47,1.47-2.92,2.25-4.39.28.12.59.24.88.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M618.33,155.88v-27.74h3.18c0,5.34.02,10.62,0,15.91-.02,3.2-.14,6.4-.24,9.6-.07,2.28-.12,2.28-2.92,2.21l-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.07,90h2.8v28.5c-1.19-.85-2.68-1.4-2.68-1.99-.14-8.8-.09-17.59-.09-26.51h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603.99,128.07h2.85v27.71c-1.73.54-2.87.4-2.87-1.85.02-8.51,0-17.02,0-25.89l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M585.07,127.95v27.79c-1.45.47-2.87.88-2.89-1.4-.05-8.7,0-17.4,0-26.24.83-.05,1.71-.07,2.89-.12v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M552.87,155.79v-27.64h3.18c0,5.38.02,10.67,0,15.96,0,3.2-.21,6.4-.21,9.6,0,2.01-.73,2.8-2.94,2.06l-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M538.55,128.1h2.8v28.47c-1.18-.83-2.68-1.38-2.68-1.97-.14-8.8-.09-17.59-.09-26.53l-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M509.27,155.76v-27.67c1-.05,1.87-.1,3.18-.14,0,4.5.05,8.87,0,13.25-.05,4.2-.24,8.42-.26,12.61,0,2.09-.88,2.66-2.92,1.97v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M628.55,122.12v27.08c0,2.11-1.09,2.28-2.96,1.73v-17.99c0-2.92.21-5.81.19-8.72,0-2.06.78-2.75,2.77-2.11v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M817.98,43.74c0,7.11.19,14.25-.12,21.36-.1,2.09-1.66,4.1-3.2,5.95,0-8.49-.07-16.95.12-25.44,0-.88,1.54-1.73,2.37-2.58.28.24.57.47.85.71h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1040.24,149.57v-25.04c.9-.26,1.8-.55,3.25-.97v22.33q0,2.68-3.23,3.67h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M480.26,124.44c.9-.26,1.85-.52,3.1-.85,0,8.04.07,15.74-.09,23.45,0,.93-1.45,1.83-2.23,2.75-.26-.17-.5-.31-.76-.47v-24.87h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.04,152.89v-24.85c3.2-.07,3.22-.07,3.22,2.85,0,6.42-.07,12.83.05,19.25.05,2.32-.88,3.06-3.27,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M938.44,124.04c3.51,3.94,3.37,9.01,3.23,14.13-.12,4.31-.02,8.63-.02,13.21-1.18-.05-2.13-.09-3.2-.14v-27.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M490.62,119.46c0,7.61.1,15.25-.1,22.86-.02,1.21-1.47,2.37-2.25,3.56-.31-.14-.64-.28-.95-.43,0-7.78-.1-15.55.12-23.33.02-1.04,1.57-2.04,2.4-3.06.26.14.54.26.81.4h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M465.48,39.71c1.38.28,2.23.45,3.2.66v24.75c-2.3-1.87-3.39-3.96-3.27-6.97.24-6,.07-12,.07-18.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1025.59,39.66c1.33.31,2.28.5,3.25.73v24.51c-2.3-1.85-3.46-3.7-3.32-6.66.26-6.07.07-12.16.07-18.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M494.58,139.07c0-7.23-.1-14.46.1-21.69.02-1.16,1.38-2.3,2.09-3.44.36.17.73.31,1.09.47,0,7.07.12,14.13-.12,21.17-.05,1.3-1.61,2.56-2.46,3.84l-.69-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M941.64,54.2c0,7.28.14,14.37-.12,21.43-.05,1.23-1.76,2.39-3.15,4.17v-23.78c1.04-.57,2.04-1.14,3.3-1.83h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.29,43.2c0,6.4.19,12.83-.12,19.2-.1,1.75-1.68,3.44-3.2,5,0-7.44-.07-14.91.09-22.36,0-.88,1.47-1.73,2.28-2.61.31.26.62.5.95.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.54,128.07c0,6.83.09,13.68-.12,20.51-.02.97-1.56,1.92-2.42,2.87-.26-.17-.52-.36-.78-.52,0-7.02-.07-14.03.09-21.05,0-.85,1.42-1.68,2.2-2.54.33.24.69.5,1.02.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.39,77.36h-2.99v-22.24c.95.14,1.97.31,2.99.47v21.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.71,41.84c0,6.24.24,12.47-.14,18.66-.12,2.09-1.87,4.05-3.18,6.71,0-8.35-.07-16.03.09-23.68,0-.83,1.47-1.64,2.25-2.47.31.26.64.52.95.78h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.82,124.71c0,6.61.12,13.25-.12,19.87-.05,1.18-1.52,2.35-2.32,3.51l-.9-.47c0-6.8-.09-13.61.12-20.41.02-1.02,1.59-1.99,2.44-2.99l.76.52.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.38,129.28h2.99v21.79h-2.99v-21.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M832.37,64.23c-2.87-1.9-3.41-4.62-3.25-7.92.26-5,.07-10.03.07-15.27,1.14-.05,2.09-.09,3.18-.17v23.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M621.41,62.02c-2.23-1.99-3.39-3.91-3.25-6.85.29-5.19.07-10.43.07-15.88,1.11-.07,2.06-.12,3.18-.19v22.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.89,40.66v20.37c-1.07-.21-2.02-.43-3.22-.66,0-6.02-.09-12.04.09-18.07.02-.83,1.45-1.64,2.2-2.47.31.26.59.52.9.81l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1018.43,61.71v-21.29c1.02-.07,1.97-.14,3.2-.21,0,6.38.1,12.47-.12,18.56-.02.85-1.66,1.64-3.08,2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M461.38,59.89c-.85.28-1.8.59-2.99,1v-20.46c.95-.07,1.87-.14,2.99-.24v19.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.84,151.68h-3.15v-19.89c2.23.26,3.32,1.09,3.23,3.6-.21,5.31-.07,10.62-.07,16.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.46,128.66h3.08c0,5.88.12,11.66-.12,17.45-.05,1.04-1.54,2.01-2.96,2.68v-20.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.48,41.87v18.97c-.99.09-1.92.17-3.22.28,0-6.19-.1-12.11.12-18.02,0-.69,1.57-1.35,2.42-2.02.24.26.47.52.69.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M872.98,123c1.21.1,2.06.17,3.18.26,0,5.74.14,11.36-.12,16.93-.05,1.21-1.57,2.35-2.42,3.53-.21-.14-.43-.26-.64-.4v-20.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M825.04,60.86c-.9.26-1.83.55-2.96.88v-19.46c1-.17,1.85-.31,2.96-.5v19.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1025.73,79.09c.95-.31,1.9-.59,3.2-1,0,6.24.1,12.14-.12,18.02-.02.78-1.61,1.54-3.08,2.84v-19.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M468.8,77.5c0,6.71.1,12.54-.09,18.35-.02.9-1.42,1.73-2.18,2.61-.33-.19-.69-.36-1.02-.55,0-5.97-.1-11.95.12-17.92.02-.71,1.71-1.38,3.18-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M458.21,99.88c0-5.6-.12-11.19.12-16.79.05-1.02,1.54-1.97,2.37-2.96.28.19.55.38.83.57,0,5.69.12,11.4-.12,17.09-.05.97-1.49,1.87-2.28,2.82-.31-.24-.62-.47-.92-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1018.33,100.12c0-5.81-.09-11.64.12-17.43.03-.85,1.59-1.66,2.42-2.47.26.19.52.36.78.55,0,5.81.12,11.62-.11,17.43-.03.85-1.64,1.66-2.49,2.49-.24-.19-.48-.38-.69-.55l-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M945.72,151.61v-19.3c2.28.14,3.32.97,3.23,3.34-.17,4.41-.14,8.84,0,13.25.05,2.18-.52,3.29-3.23,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M897.9,48.6v19.94c-2.32-.24-3.39-1.21-3.3-3.67.17-4.2.17-8.42,0-12.61-.09-2.44.9-3.49,3.3-3.63v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.79,62.04c-2.35-1.97-3.37-4.27-3.15-7.35.28-4.08.07-8.2.07-12.47,1.11-.09,1.97-.19,3.08-.28v20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M825.23,88.55c0,5.31.24,10.34-.12,15.32-.12,1.73-1.68,3.34-3.2,4.74,0-5.88.05-11.76-.02-17.64-.02-2.25,1.45-2.23,3.34-2.39v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.02,122.62c.93-.05,1.78-.07,3.01-.14,0,5.24.17,10.31-.12,15.39-.07,1.38-1.54,2.68-2.92,3.84v-19.09h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M662,60.84v-18.47h3.18c0,5.12.19,10.03-.12,14.89-.07,1.33-1.61,2.56-2.49,3.84-.19-.09-.38-.19-.59-.28l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.59,42.2h3.08c0,5.12.17,10.1-.12,15.08-.07,1.19-1.61,2.3-2.96,4.13v-19.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.44,123.26c2.06-.29,3.18.28,3.11,2.68-.14,3.41-.17,6.83,0,10.24.14,2.49-.78,4.22-3.11,5.67v-18.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.57,88.22c0,4.6.19,9.2-.12,13.77-.1,1.4-1.52,2.7-2.32,4.06-.28-.09-.59-.21-.88-.31,0-5.33-.1-10.67.12-16,.02-.76,1.57-1.45,2.42-2.16.26.21.52.43.78.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M832.39,102.66c-1.11-.07-2.09-.12-3.18-.19,0-4.6-.19-9.13.12-13.63.1-1.33,1.59-2.56,2.42-3.84.21.12.43.24.64.36v17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M745.12,42.37v17.71c-4.98-4.1-2.73-9.74-3.25-14.79-.24-2.32.88-3.03,3.25-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.95,150.5h-2.99v-15.17h2.99v15.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.87,138.88c-.71-.69-2.01-1.35-2.04-2.06-.19-4.46-.1-8.94-.1-13.59.81-.05,1.68-.07,2.8-.12v14.94c-.21.29-.43.57-.66.85v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.81,113.54c-.69-.74-1.9-1.45-1.94-2.21-.19-4.39-.09-8.77-.09-13.44.76-.05,1.68-.12,2.82-.19v15.29c-.26.19-.52.38-.81.55h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M516.55,151.8v-15.88h2.82c0,4.67.07,9.34-.1,13.99,0,.55-1.47,1.04-2.73,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M531.25,135.94h2.84v15.03c-1.64.45-2.87.47-2.84-1.8.02-4.29,0-8.58,0-13.21v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M560.15,150.83v-14.86c1-.05,1.94-.1,2.89-.14,0,4.76.09,9.34-.1,13.89-.02.66-1.35,1.26-2.09,1.87-.24-.26-.47-.52-.71-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M574.9,135.92h2.84v15.05c-1.52.38-2.84.64-2.84-1.59v-13.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M599.53,151c-1.78.5-2.87.28-2.85-1.8.05-4.29,0-8.58,0-13.21.71-.05,1.66-.12,2.82-.21v15.22h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M727.53,42.77c2.3-.19,3.25.73,3.18,2.94-.07,2.42-.12,4.84,0,7.23.12,2.3-1.11,3.41-3.18,4.41v-14.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.51,136.42v13.84c-4.43-1.73-4.65-10.12,0-13.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M679.64,43.01v13.44c-4.53-3.25-4.67-10.34,0-13.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M890.62,52.73v12.28c-.24.17-.5.33-.73.5-.83-1.26-2.21-2.42-2.4-3.77-.78-5.6-.24-6.85,3.13-9.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M788.86,115.29v23.19c-2.35-7.73-2.04-15.48,0-23.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M953.07,135.54c3.72,3.63,3.68,10.79,0,14.11v-14.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M614.16,44.83v9.25c-2.77.5-2.82.5-2.89-1.97-.05-1.8.02-3.6,0-5.41-.05-2.16.99-2.54,2.92-1.87h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.11,109.82c-3.27.33-3.56-.52-2.68-8.3h2.68v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.41,109.86c-3.13.83-3.11.57-2.84-8.27h2.84v8.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M526.87,148.08h-3.01v-6.66h3.01v6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M570.44,148.08h-2.96v-6.69h2.96v6.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1062.2,73.71c1.23,4.81,2.06,9.1,0,13.44v-13.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.09,44.05v10c-2.7-2.99-2.77-6.57,0-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.75,53.94v-9.6c2.06,2.18,2.13,6.64,0,9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.15,65.67v11.36h-.54v-11.36h.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.63,45.33v7.8h-.76v-7.8h.76Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCw);
export default __webpack_public_path__ + "static/media/cw.935ae3fc4850c8ff8b41f81686f01776.svg";
export { ForwardRef as ReactComponent };